// extracted by mini-css-extract-plugin
var _1 = "vN0uw__verificationInfo";
var _2 = "vN0uw__verificationInfo__entry";
var _3 = "vN0uw__verificationInfo__value";
export { _1 as "verificationInfo", _2 as "verificationInfo__entry", _3 as "verificationInfo__value" }
